// Single source of truth for colors / spacing / radii used by both MUI and Tailwind.
export const colors = {
  primary: "#48A6A7",      // Terakki turkuazı (mobil app Colors.theme.second)
  primaryDark: "#006A71",  // mobil app Colors.theme.first
  primaryLight: "#8FC9CA",
  success: "#1A5D1A",
  warning: "#E8A23A",
  error: "#C0392B",
  neutral: "#6C757D",
  surface: "#FFFFFF",
  surfaceAlt: "#F7F7F7",
  border: "#E2E8F0",
  textPrimary: "#222831",
  textSecondary: "#6C757D",
  textInverse: "#FFFFFF",
};

// Koyu tema: mobil uygulamadaki DARK tonlarıyla aynı (constants/darkTone.ts).
export const darkColors = {
  gradientFrom: "#006A71",
  gradientTo: "#123B3D",
  bg: "#123B3D",
  paper: "#17474A",
  text: "#FFFFFF",
  muted: "rgba(255, 255, 255, 0.7)",
  faint: "rgba(255, 255, 255, 0.45)",
  line: "rgba(255, 255, 255, 0.14)",
  chip: "rgba(255, 255, 255, 0.1)",
  pressed: "rgba(255, 255, 255, 0.08)",
  soft: "#8FC9CA",
  brand: "#48A6A7",
  success: "#7BE3A8",
  danger: "#F2A59C",
};

export const spacing = {
  xs: "4px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "48px",
};

export const radius = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  pill: "9999px",
};

export const fonts = {
  body: "'Nunito', system-ui, sans-serif",
};
